


























































































































import { searchStudent } from "@/api/globalSearch";
import { PageModule } from "@/store/module/page";
import { Prop, Vue, Component } from "vue-property-decorator";
@Component
export default class extends Vue {
  @Prop() oriIds!: any[];
  @Prop({ type: Array, default: () => [] }) disableItems!: any[];
  @Prop() dialogType?: string;
  cacheList: any[] = [];
  selectedObject: any = {};
  selectedList: any[] = [];
  dialogVisible = false;
  searchInfo: any = {};
  tableData: any[] = [];
  page: number = 1;
  pageSize: number = 10;
  pageSizeArray: number[] = [5, 10, 30, 50, 100];
  total: number = 0;

  created() {
    // 如果是从学员详情或者意向学员进入的，自动加载缓存中的学员信息
    if (
      PageModule.latestRoute === "studyDetails" ||
      PageModule.latestRoute === "latent"
    ) {
      const cache = PageModule.pageInfo.recruitExperienceList.selected_student;
      if (cache) {
        this.selectedList = [cache];
        this.cacheList = [cache];
        this.selectedObject[cache.student_id] = cache;
        this.$emit("update:oriIds", [cache.student_id]);
      }
    }
  }
  // beforeDestroy() {
  //   PageModule.SET_PAGE_INFO({
  //     name: "recruitExperienceList",
  //     key: "selected_student",
  //     value: null,
  //   });
  // }
  showDialog() {
    this.dialogVisible = true;
    this.getList({
      page: 1,
      page_size: this.pageSize,
    });
  }
  handleCancel() {
    const copy = [...this.cacheList];
    const ids: number[] = [];
    const obj: any = {};
    copy.map((item: any) => {
      ids.push(Number(item.student_id));
      obj[item.student_id] = item;
    });
    this.selectedList = copy;
    this.selectedObject = obj;
    this.dialogVisible = false;
    this.$emit("update:oriIds", ids);
  }
  handleConfirm() {
    const copy = [...this.selectedList];
    const ids: number[] = [];
    const obj: any = {};
    copy.map((item: any) => {
      ids.push(Number(item.student_id));
      obj[item.student_id] = item;
    });
    this.selectedObject = obj;
    this.cacheList = copy;
    this.dialogVisible = false;
    this.$emit("update:oriIds", ids);
  }
  handleCourseSelect(row: any) {
    const copy = { ...this.selectedObject };
    if (copy[row.student_id]) {
      delete copy[row.student_id];
    } else {
      copy[row.student_id] = row;
    }
    this.selectedObject = copy;
    const items = [];
    for (const key in copy) {
      items.push(copy[key]);
    }
    this.selectedList = items;
    const index = this.tableData.findIndex((item: any) => {
      return item.student_id === row.student_id;
    });
    if (index >= 0) {
      this.tableData[index].checked = !!copy[row.student_id];
    }
  }
  handleSearch() {
    this.getList({
      page: 1,
      page_size: this.pageSize,
    });
  }
  getList(params: { page: number; page_size: number }) {
    const option: any = {
      page: params.page,
      page_size: params.page_size,
      status: [1, 2],
    };
    if (this.searchInfo.key_word) {
      option.key_word = this.searchInfo.key_word;
    }
    searchStudent(option).then((res: any) => {
      const disableIds = this.disableItems.map((item: any) => {
        return item.student_id;
      });
      res.data.list.map((item: any) => {
        if (this.selectedObject[item.student_id]) {
          item.checked = true;
        } else {
          item.checked = false;
        }
        if (disableIds.includes(item.student_id)) {
          item.checked = true;
          item.disable = true;
        } else {
          item.disable = false;
        }
      });
      this.tableData = res.data.list;
      this.total = res.data.total;
      this.page = res.data.page;
    });
  }
  handlePagerChange(e: number) {
    this.getList({
      page: e,
      page_size: this.pageSize,
    });
  }
  handlePagerSizeChange(e: number) {
    this.pageSize = e;
    this.getList({
      page: 1,
      page_size: e,
    });
  }
}
